import React from 'react';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { Highlight } from '@src/components/ProgramDetails/ProgramHighlightsPanel/Highlight/Highlight';
import { convertCompletionTime } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const CompletionTimeHighlight: React.FC<Props> = ({ program, loading }) => {
	const displayCompletionTime =
		program?.minCompletionTimeDisplay &&
		program?.maxCompletionTimeDisplay &&
		program?.completionTimeDisplay;

	return (
		<>
			{displayCompletionTime && (
				<Highlight
					body={
						<Typography>
							{convertCompletionTime(program?.maxCompletionDays, program?.minCompletionDays)}
						</Typography>
					}
					label='Length'
					loading={loading}
					popoverContent='This is an estimate of the amount of time it may take to complete this program, but it depends on the number of credits you take each term, the number of terms you enroll in each year, and your continued academic progress.'
				/>
			)}
		</>
	);
};
